import React, { useState } from "react";
import styles from './scss/resetPassword.module.scss';
//import loaderblue from '../styles/images/loaderblue.svg';
import resetlink from '../../styles/images/resetlink.svg';
import { Link } from "react-router-dom";
import { LoginService } from "../../base/loginService";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../styles/images/br-login-animated-dots-black.json";
import ContactLoader from "../../styles/images/Lottie Animation.json";
// import recentlink from '../styles/images/recentlink.svg';
type ResetLinkProps = {
  updateState:(state:string)=>void;
  email:string;
}
const ResetLink = ({updateState,email}:ResetLinkProps) =>{
  const [loading, setLoading] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);

  const onSubmit = async() => {
    setLoading(true);
    if(email){
      const finalObj = {
        called_by: "APP",
        email: email,
        log_id: 0,new_pwd: "",type: 1
      };
      LoginService.forgotPassword(finalObj).then((value:any)=>{
        setLoading(false);
        setDisabled(true);
      });
    }
  };
  return (
    <>
      {/* <div className={styles.loadingSec}>
        <object data={loaderblue} type="image/svg+xml">Loading...</object>
      </div> */}
      <div className={styles.resetSection}>
        <img src={resetlink} alt="Header Logo" className={styles.logoIcon}/>
        <div className={styles.resetpassLink}>
          {/* <img src={recentlink} alt="" /> */}
          <p className={styles.resetLinkText}>Reset password link sent to email</p>
          <p className={styles.resetLinkDesc}>Please check your email in order to continue</p>
          <div className={styles.linksTag}>
            <Link to=""  onClick={()=>updateState('login')}
              className={styles.backLink}><span className="icon_outlineleftarrow"></span>
              <span className={styles.backText}>Back to login</span></Link>
            <span className={`${styles.resendLink}  ${disabled? styles.disabled:""}`} onClick={()=>onSubmit()}>
              
              {!loading?"Resend recovery link":<Lottie className="svgLoading"
                animationData={ContactLoader} />}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetLink;